import { render, staticRenderFns } from "./RunningCardsSection.vue?vue&type=template&id=33af8c46&"
import script from "./RunningCardsSection.vue?vue&type=script&lang=js&"
export * from "./RunningCardsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports